/* global axios */
import ApiClient from './ApiClient';

class WebHooks extends ApiClient {
  constructor() {
    super('webhooks', { accountScoped: true });
  }

  // Dispara um payload de teste pra URL e retorna { success, status }.
  test(url) {
    return axios.post(`${this.url}/test`, { url });
  }
}

export default new WebHooks();
